/*
  hotel-accordion-links.js
  Turns PDP trust copy into in-page links that open (and scroll to) the matching
  product-info accordion (<details> from a collapsible_tab block):

    - "Ships Free"        in .hotel-shipping-note         -> "Free NZ Shipping" accordion
    - "FREE NZ SHIPPING"  in the trust-badges iwt heading -> "Free NZ Shipping" accordion
    - "60-NIGHT GUARANTEE" in the trust-badges iwt heading -> "60-Night Guarantee" accordion

  Template-agnostic: targets are resolved from the accordions actually present on
  the page, so products using a combined "Free NZ shipping + 60-night bedding
  trial" tab still work (both links fall back to it). No-ops when a phrase or a
  target accordion is absent — so templates without the relevant copy/tab are
  unaffected. Upgrade-safe (hotel-* file); loaded from
  sections/hotel-main-product.liquid.
*/
(function () {
  function init() {
    var root = document.querySelector('.product__info-container') || document;

    // Index the product-info accordions by their visible title.
    var accordions = Array.prototype.map.call(
      root.querySelectorAll('.product__accordion details'),
      function (d) {
        var t = d.querySelector('.accordion__title');
        return { el: d, title: (t ? t.textContent : '').trim() };
      }
    );

    // First accordion whose title matches one of the patterns (tried in order).
    function findAccordion(patterns) {
      for (var p = 0; p < patterns.length; p++) {
        for (var i = 0; i < accordions.length; i++) {
          if (patterns[p].test(accordions[i].title)) return accordions[i].el;
        }
      }
      return null;
    }

    var shippingAcc = findAccordion([/free\s+nz\s+shipping/i]);
    var guaranteeAcc = findAccordion([/60[\s-]?night\s+guarantee/i, /60[\s-]?night/i]);

    function openAccordion(details) {
      if (!details) return;
      details.open = true;
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Wrap the first case-insensitive match of `re` within `container` (text
    // nodes only, so existing markup like <strong> is preserved) in a link that
    // opens `details`. No-op if either is missing or no match is found.
    function linkify(container, re, details) {
      if (!container || !details) return;
      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var m = node.nodeValue.match(re);
        if (!m) continue;
        var phrase = node.splitText(m.index); // phrase + trailing text
        phrase.splitText(m[0].length); // phrase now holds exactly the match
        var link = document.createElement('a');
        link.className = 'hotel-acc-link';
        link.setAttribute('role', 'button');
        link.setAttribute('tabindex', '0');
        link.textContent = phrase.nodeValue;
        phrase.parentNode.replaceChild(link, phrase);
        var open = function (e) {
          e.preventDefault();
          openAccordion(details);
        };
        link.addEventListener('click', open);
        link.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') open(e);
        });
        return; // only the first occurrence
      }
    }

    linkify(root.querySelector('.hotel-shipping-note'), /Ships Free/i, shippingAcc);

    var trustHeading = root.querySelector('.hotel-trust-badges-group .inline-richtext');
    linkify(trustHeading, /FREE\s+NZ\s+SHIPPING/i, shippingAcc);
    linkify(trustHeading, /60[\s-]?NIGHT\s+GUARANTEE/i, guaranteeAcc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
